import { render, staticRenderFns } from "./my_account.vue?vue&type=template&id=d2abb718&scoped=true&"
import script from "./my_account.vue?vue&type=script&lang=js&"
export * from "./my_account.vue?vue&type=script&lang=js&"
import style0 from "./my_account.vue?vue&type=style&index=0&id=d2abb718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2abb718",
  null
  
)

export default component.exports